import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    width: ${({ width }) => width || "auto"};
    height: auto;
    grid-template-columns: ${({ tempCol }) => tempCol};
    gap: ${({ gap }) => gap || "1rem"};
    margin: ${({ margin }) => margin || "0"};
    justify-content: center;

    @media (max-width: 768px) {
        grid-template-columns: ${({ mobileTempCol, tempCol }) =>
          mobileTempCol || tempCol};
    }
`;

export default Grid;
